import type {OrderProductState} from 'modules/Orders/types';

import {Badge} from '@ds/components';

import {ORDER_PRODUCT_STATE_LABELS} from '../../../../../../constants';

type OrderProductBadgeProps = {
  state?: OrderProductState;
};

const OrderProductBadge: React.FC<OrderProductBadgeProps> = ({state}) => {
  const label = state ? ORDER_PRODUCT_STATE_LABELS[state] : undefined;

  if (!state || !label) {
    return null;
  }

  const color = state === 'deleted' ? 'error' : state === 'edited' ? 'warning' : 'success';

  return (
    <Badge variant="status" size="md" color={color} className="w-fit min-w-12.5">
      {label}
    </Badge>
  );
};

export default OrderProductBadge;
